module.exports = __webpack_public_path__ + "static/media/IUP_nieakt.29462069.svg";